import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const ColorButton = withStyles((theme) => ({
	root: {
		// color: theme.palette.getContrastText(purple[500]), // ERRORBAG
		backgroundColor: '#FFFFFF',
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		borderRadius: '48px',
		textTransform: 'none',
		height: '100%',
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '18px',
		lineHeight: '23px',
		color: '#3C3C56',                                    // ERRORBAG
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3),
		"&:hover": {
			backgroundColor: '#FFFFFF'
		}
	},
}))(Button);

export default function SecondaryButton(props) {

	return (
		<ColorButton variant="contained" color="primary" style={{ lineHeight: (props.height - 12) + 'px', margin: props.margin, minWidth: props.width ? props.width : 'unset' }} onClick={props.onClick} /* className={classes.margin} */>
			{props.text}
		</ColorButton>
	);
}